import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FilterBadge from './FilterBadge';
import { getEstadoColor, getSubEstadoColor } from '../constants/reservaColors';

/**
 * Componente que renderiza todos los filtros de estado y sub-estado
 * 
 * @param {Object} estadosActivos - Estados activos
 * @param {Object} subEstadosActivos - Sub-estados activos
 * @param {function} toggleEstado - Función para toggle de estado
 * @param {function} toggleSubEstado - Función para toggle de sub-estado
 * @param {Array} estadosDisponibles - Array de estados a mostrar (opcional)
 * @param {Array} subEstadosDisponibles - Array de sub-estados a mostrar (opcional)
 */
const ReservaFilters = ({
  estadosActivos,
  subEstadosActivos,
  toggleEstado,
  toggleSubEstado,
  estadosDisponibles = ['activo', 'inactivo', 'cancelado'],
  subEstadosDisponibles = [
    'bolsa',
    'asignada_espera',
    'en_curso',
    'completado_sin_confirmar',
    'pendiente_devolucion',
    'pendiente_pago',
    'finalizado',
    'fallido',
    'cancelado_cliente',
    'cancelado_administrador',
    'cancelado_automatico'
  ]
}) => {
  const { t } = useTranslation();

  return (
    <>
      {/* Filtros de Estado */}
      <Text className="filter-section-title">
        {t('filtros_estados_titulo') || 'Estados'}
      </Text>
      <Box className="filter-container">
        {estadosDisponibles.map(estado => (
          <FilterBadge
            key={estado}
            colorScheme={getEstadoColor(estado)}
            isActive={estadosActivos[estado]}
            onClick={() => toggleEstado(estado)}
            label={t(`estado_${estado}`)}
          />
        ))}
      </Box>

      {/* Filtros de Sub-Estado */}
      <Text className="filter-section-title">
        {t('filtros_subestados_titulo') || 'Sub-Estados'}
      </Text>
      <Box className="filter-container">
        {subEstadosDisponibles.map(subEstado => (
          <FilterBadge
            key={subEstado}
            colorScheme={getSubEstadoColor(subEstado)}
            isActive={subEstadosActivos[subEstado]}
            onClick={() => toggleSubEstado(subEstado)}
            label={t(`subestado_${subEstado}`)}
          />
        ))}
      </Box>
    </>
  );
};

ReservaFilters.propTypes = {
  estadosActivos: PropTypes.object.isRequired,
  subEstadosActivos: PropTypes.object.isRequired,
  toggleEstado: PropTypes.func.isRequired,
  toggleSubEstado: PropTypes.func.isRequired,
  estadosDisponibles: PropTypes.arrayOf(PropTypes.string),
  subEstadosDisponibles: PropTypes.arrayOf(PropTypes.string)
};

export default ReservaFilters;
